<template>
    <div class="banner">
        <div class="bannerimg"><img :src="infodata.banner" /></div>
        <div class="csite"><div class="info realwrap"><router-link to="/">{{$common.dicword('homepage')}}</router-link><span>&gt;</span><span>{{$common.langinfo(infodata.title,infodata.title_en)}}</span></div></div>
    </div>
</template>

<script>
    export default {
        name: 'ffbanner',
        data() {
            return {
                footerinfo: ''
            }
        },
        props: {
            infodata: {
                type: Object,
                default: () => { }
            }
        }
    };
</script>
